import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { forkJoin, Observable } from 'rxjs';
import { getSessionId, saveToStorage } from '../../helpers/storageUtils';
import { DatosGenerales } from '../../Models/datosGenerales';
import { DatosPlanes } from '../../Models/datosPlanes';
import { Planes } from '../../Models/planes';
import { COTIZACION_PAUSA, PLANES } from '../../routes.constans';
import { ExceptionService } from '../../services/excepciones/exception.service';
import { PlanesService } from '../../services/Planes/planes.service';
import { WebMPlayerComponent } from '../../shared/components/web-mplayer/web-mplayer.component';
import { PROBLEMAS_TECNICOS_REDIRECT } from '../../shared/final-pages/final-pages.constants';
import { selectData } from '../../storage/Lead/data.selectors';
import { loadPlanes, updatePlanes } from '../../storage/Planes/planes.action';
import { selectPlanes } from '../../storage/Planes/planes.selector';
import { BannerAppComponent } from '../banner-app/banner-app.component';

@Component({
  selector: 'app-loader-moto',
  standalone: true,
  imports: [BannerAppComponent, WebMPlayerComponent],
  templateUrl: './loader-moto.component.html',
  styleUrl: './loader-moto.component.scss',
})
export class LoaderMotoComponent implements OnInit {
  exceptionService = inject(ExceptionService);
  minutos!: number;
  segundos!: number;
  id: any;

  codAsesor = '';
  nombreCliente = '';
  sessionId = '';

  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  datosPlanes: DatosPlanes = {
    lead_id: '',
    planes: {
      data: {
        products: [
          {
            coveragesGroup: [
              {
                Name: '',
                Include: false,
                Description: '',
              },
            ],
            coverages: [
              {
                price: 0,
                description: '',
                name: '',
              },
            ],
            order: 1,
            code: '',
            priceMensual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            priceAnual: {
              currency: '',
              amount: 0,
              formatted: '',
            },
            name: '',
          },
        ],
      },
      FalloTarifaEsencialMotos: false,
      FalloTarifaTotalMotos: false,
    },
    payment_frequency: '',
    selected_plan: '',
    coberturasOpcionales: [],
  };

  datosPlanesConsulta: DatosPlanes | null = null;
  datosPlanesConsulta$: Observable<DatosPlanes | null>;

  leadId: Lead = {
    lead_id: '',
    productCode: '',
  };

  leadId2: Lead = {
    lead_id: '',
    productCode: '',
  };

  leadId3: Lead = {
    lead_id: '',
    productCode: '',
  };

  public planes!: Planes;
  public planesList: Planes = {
    data: {
      products: [
        {
          coveragesGroup: [
            {
              Name: '',
              Include: false,
              Description: '',
            },
          ],
          coverages: [
            {
              price: 0,
              description: '',
              name: '',
            },
          ],
          order: 1,
          code: '',
          priceMensual: {
            currency: '',
            amount: 0,
            formatted: '',
          },
          priceAnual: {
            currency: '',
            amount: 0,
            formatted: '',
          },
          name: '',
        },
      ],
    },
    FalloTarifaEsencialMotos: false,
    FalloTarifaTotalMotos: false,
  };

  public planesListTemp?: Planes;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private planesService: PlanesService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanesConsulta$ = this.store.select(selectPlanes);
  }

  ngOnInit(): void {
    this.sessionId = getSessionId().toString();
    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe((params) => {
      this.codAsesor = params['codigoAsesor'] || '';
      console.log('Código Asesor en Loader Moto:', this.codAsesor);
    });

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });

    this.nombreCliente = this.datosGenerales?.LeadResponse.data.vehicle.owner.firstnames ?? '';

    if (this.datosPlanes) {
      this.datosPlanes.lead_id = this.datosGenerales?.LeadResponse.data.Id ?? '';
      this.leadId.lead_id = this.datosPlanes.lead_id;
      this.leadId.productCode = 'MOTOS_PlanEsencial';

      this.leadId2.lead_id = this.datosPlanes.lead_id;
      this.leadId2.productCode = 'MOTOS_PlanTotal';

      this.leadId3.lead_id = this.datosPlanes.lead_id;
      this.leadId3.productCode = 'MOTOS_PlanPremium';
    }

    this.store.dispatch(loadPlanes({ data: this.datosPlanes }));
    this.fetchAllPlanes();
  }

  public fetchAllPlanes() {
    const requests = [
      this.planesService.getPlanes(this.sessionId, this.leadId),
      this.planesService.getPlanes(this.sessionId, this.leadId2),
      this.planesService.getPlanes(this.sessionId, this.leadId3),
    ];

    forkJoin(requests).subscribe({
      next: (responses) => {
        console.log('All responses:', responses);
        saveToStorage('validPlans', responses, 'session');

        // Validar si algún plan tiene LimiteMinimoTarifaAutos en true
        const falloTarifa = responses.some((plan: any) => plan?.LimiteMinimoTarifaMotos === true);

        const validResponses = responses.filter((response) => response !== null); // Filtrar respuestas válidas

        // Procesamiento de respuestas válidas
        this.planesList = {
          data: {
            products: validResponses.flatMap((response) =>
              response && response.data && response.data.products ? response.data.products : [],
            ),
          },
          FalloTarifaEsencialMotos: false,
          FalloTarifaTotalMotos: false,
        };
        const safePlanesList = {
          data: this.planesList.data || { products: [] },
          FalloTarifaEsencialMotos:
            this.planesList.FalloTarifaEsencialMotos !== undefined
              ? this.planesList.FalloTarifaEsencialMotos
              : false,
          FalloTarifaTotalMotos:
            this.planesList.FalloTarifaTotalMotos !== undefined
              ? this.planesList.FalloTarifaTotalMotos
              : false,
        };

        this.store.dispatch(updatePlanes({ lplans: safePlanesList }));

        const navigateOptions = {
          queryParams: this.codAsesor ? { codigoAsesor: this.codAsesor } : {},
        };

        if (responses.length === 0) {
          this.exceptionService
            .addException(this.sessionId, this.leadId.lead_id, {
              required_status: 'Falla conexión cálculo tarifa',
              percentege_lead: '45',
              estadoRescate: 'Habilitado',
            })
            .subscribe((response) => {
              if (response.data.Success === true) {
                this.router.navigate([PROBLEMAS_TECNICOS_REDIRECT], navigateOptions);
              }
            });
        } else if (falloTarifa) {
          this.exceptionService
            .addException(this.sessionId, this.leadId.lead_id, {
              required_status: 'Tarifa Inferior',
              percentege_lead: '45',
              estadoRescate: 'Habilitado',
            })
            .subscribe({
              next: (resp) => {
                console.log('Se actualizo el porcentaje de la excepción');
                this.router.navigate([COTIZACION_PAUSA], navigateOptions);
              },
              error: (error) => {
                console.error('Error al actualizar el porcentaje de la excepción:', error);
                this.router.navigate([COTIZACION_PAUSA], navigateOptions);
              },
            });
        } else {
          this.router.navigate([PLANES], navigateOptions);
          //this.router.navigate([ONEROSO], navigateOptions);
        }
      },
      error: (error) => {
        console.error('Error in completing all requests:', error);
        this.navigateOnError();
      },
      complete: () => {
        console.log('All requests completed.');
      },
    });
  }

  private navigateOnError(): void {
    const navigateOptions = {
      queryParams: this.codAsesor ? { codigoAsesor: this.codAsesor } : {},
    };
    this.router.navigate([COTIZACION_PAUSA], navigateOptions);
  }
}

export interface Lead {
  lead_id: string;
  productCode: string;
}
